
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/list/[...slug]",
      function () {
        return require("private-next-pages/blog/list/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/list/[...slug]"])
      });
    }
  